import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormaterPipe } from '@pipes/formater/formater.pipe';

@NgModule({
    declarations: [FormaterPipe],
    exports: [FormaterPipe],
    imports: [CommonModule],
})
export class FormatterModule {}
